import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
import { DrawSVGPlugin } from 'gsap/DrawSVGPlugin'

gsap.registerPlugin(ScrollTrigger, DrawSVGPlugin)

export default function initDrawLines() {
  document.querySelectorAll('[data-draw]').forEach((wrap) => {
    const path = wrap.querySelector('path')
    if (!path) return

    const stroke = path.getAttribute('stroke')
    const hasStroke = stroke && stroke !== 'none'

    // trait réel (stroke) : dessin progressif via drawSVG
    // forme pleine (fill, ex: coup de pinceau) : drawSVG n'a pas d'effet visible sans stroke, on simule via clip-path
    if (hasStroke) {
      gsap.set(path, { drawSVG: '0%' })
    } else {
      gsap.set(wrap, { clipPath: 'inset(0 100% 0 0)' })
    }

    gsap.to(hasStroke ? path : wrap, {
      [hasStroke ? 'drawSVG' : 'clipPath']: hasStroke ? '100%' : 'inset(0 0% 0 0)',
      duration: 1.2,
      ease: 'power2.inOut',
      scrollTrigger: {
        trigger: wrap,
        start: 'top 85%',
        toggleActions: 'play none none none',
      },
    })
  })
}
